// Indian currency + real-estate formatting helpers

export function formatINR(value) {
  if (value == null || isNaN(value)) return "—";
  const v = Number(value);
  if (v >= 10000000) {
    const cr = v / 10000000;
    return `₹${cr % 1 === 0 ? cr : cr.toFixed(2)} Cr`;
  }
  if (v >= 100000) {
    const l = v / 100000;
    return `₹${l % 1 === 0 ? l : l.toFixed(2)} L`;
  }
  return `₹${v.toLocaleString("en-IN")}`;
}

export function formatPriceRange(min, max) {
  return `${formatINR(min)} - ${formatINR(max)}`;
}

export function formatRent(value) {
  return `${formatINR(value)}/mo`;
}

export function formatNumber(value) {
  return Number(value || 0).toLocaleString("en-IN");
}

export function configLabel(p) {
  if (["Plot", "Farm Land", "Villa Plot", "Gated Plot", "Commercial Plot", "Investment Land"].includes(p.property_type)) {
    return `${formatNumber(p.area_sqft)} sq.ft plot`;
  }
  if (p.bedrooms > 0) return `${p.bedrooms} BHK ${p.property_type}`;
  return p.property_type;
}

export const CATEGORY_LABELS = {
  residential: "Residential",
  plots: "Plots & Land",
  commercial: "Commercial",
  luxury: "Luxury",
  investment: "Investment",
};
